<template>
  <div>
    <div v-for="duties in dutiesByMonth" :key="duties.yearMonth">
      <v-row>
        <div class="mt-8 ml-4 chip primary darken-1 white--text op-text-l">{{ getMonthTitle(duties.yearMonth) }}</div>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="4" v-for="(duty, index) in duties.listOfDuties" :key="index">
          <duty-card class="mb-3" :duty="duty" @click="$emit('onDutySelected', duty)"> </duty-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import DutyCard from '@/modules/myDuties/components/DutyCard.vue';
import dutiesUtil from '@/modules/myDuties/common/dutiesUtil';

export default {
  components: { DutyCard },
  props: {
    dutiesByMonth: Array,
  },
  methods: {
    /**
     * Year and month in String form ${year}_${month_zero_based}
     * @param yearMonth
     * @returns {string}
     */
    getMonthTitle(yearMonth) {
      return dutiesUtil.getMonthTitle(yearMonth, this.locale);
    },
  },
};
</script>
